module.exports = __webpack_public_path__ + "mainassets/img/bgwhite.838a2683.svg";